<template>
  <div :id="modalsContainerId">
    <modal
      v-for="modal in modals"
      :key="modal.id"
      v-bind="modal.modalAttrs"
      v-on="modal.modalListeners"
      @closed="remove(modal.id)"
    >
      <component
        :is="modal.component"
        v-bind="modal.componentAttrs"
        v-on="$listeners"
        @close="$bvmModal.hide(modal.modalAttrs.name, $event)"
      />
    </modal>
  </div>
</template>

<script>
/**
 * A container component for modal components.
 * This component is registered automatically in a new Vue instance on the bottom of the body when this plugin is loaded/installed.
 * See main.js for how this is done.
 */
import Modal from "./modal";
import { StringUtil } from "../../utils";

const ID_PREFIX = "modals-container-";
const PREFIX = "bvm_modal_";

export default {
  name: "modals-container",
  components: { Modal },
  data() {
    return {
      modalsContainerId: ID_PREFIX,
      modals: []
    };
  },
  created() {
    // Set unique id for this modalsContainer Vue instance
    this.modalsContainerId = ID_PREFIX + this.$bvmModal.config.implementerName;

    // Register ModalContainer so that it was available inside the plugin
    // Note: this.$root is the Vue (root) instance of the caller
    this.$root.__bvmModalContainer = this;
  },
  mounted() {
    this.$bvmModal.subscription.$on("hide-all", () => {
      this.modals = [];
    });
  },
  methods: {
    add(component, componentAttrs = {}, modalAttrs = {}, modalListeners = {}) {
      const id = StringUtil.randomString();
      const name = modalAttrs.name || PREFIX + id;

      this.modals.push({
        id,
        modalAttrs: { ...modalAttrs, name },
        modalListeners,
        component,
        componentAttrs
      });

      this.$nextTick(() => {
        this.$bvmModal.show(name);
      });

      return name;
    },
    remove(id) {
      const index = this.modals.findIndex(v => v.id === id);
      if (index !== -1) {
        this.modals.splice(index, 1);
      }
    }
  }
};
</script>
